import { useEffect, useState } from "react";

const useScrollEffects = () => {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // const lockThreshold = 0;
  // const isLocked = scrollY > lockThreshold;
  // const isScrolled = scrollY >= lockThreshold && scrollY < 11;

  const isLocked = false;
  const isScrolled = false;
  const hidderVisible = false

  const backgroundStyles = {
    height: isLocked ? "80vh" : "100vh",
    width: isLocked ? "90%" : "100%",
    position: isScrolled ? "fixed" : "sticky",
    top: isLocked ? "15vh" : "0",
    left: isLocked ? "5%" : "0",
    borderRadius: isLocked ? "20px" : "0px",
    transition: "all 0.4s ease",
  };

  const heroTextVisible = scrollY < 350;
  // const hidderVisible = scrollY >= 3 && scrollY < 1000;

  const introFadeStart = 30;
  const introFadeEnd = 70;
  const introOpacity =
    scrollY < introFadeStart
      ? 0
      : scrollY > introFadeEnd
      ? 1
      : (scrollY - introFadeStart) / (introFadeEnd - introFadeStart);

  return {
    backgroundStyles,
    heroTextVisible,
    introOpacity,
    hidderVisible,
  };
};

export default useScrollEffects;
